import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Media from 'react-media';
import colors from '../../../styled/colors';
import mediaQueries from '../../../utils/mediaQueries';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  @media ${mediaQueries.lgPlusUp} {
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: space-between;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 58px;
    picture {
      justify-self: center;
    }
    &:nth-child(even) {
      picture {
        order: 2;
      }
      div {
        margin-left: 48px;
      }
    }
  }
  @media ${mediaQueries.xlPlusUp} {
    &:nth-child(even) {
      div {
        margin-left: 0;
      }
    }
  }
  &:not(:last-child) {
    margin-bottom: 48px;
    @media ${mediaQueries.mdUp} {
      margin-bottom: 63px;
    }
    @media ${mediaQueries.lgPlusUp} {
      margin-bottom: 70px;
    }
    @media ${mediaQueries.xlPlusUp} {
      margin-bottom: 40px;
    }
  }
`;
const ImageContainer = styled.picture`
  display: block;
  max-width: 243px;
  max-height: 189px;
  @media ${mediaQueries.mdUp} {
    max-width: 352px;
    max-height: 274px;
  }
  @media ${mediaQueries.lgPlusUp} {
    max-width: 398px;
    max-height: 311px;
  }
  @media ${mediaQueries.xlPlusUp} {
    max-width: 450px;
    max-height: 350px;
  }
`;
const Image = styled.img`
  width: 100%;
`;
const Description = styled.div`
  margin-top: 18px;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  @media ${mediaQueries.mdUp} {
    margin-top: 10px;
  }
  @media ${mediaQueries.lgPlusUp} {
    height: fit-content;
    justify-content: flex-start;
    flex: 1;
    margin-top: 48px;
    max-width: 480px;
  }
  @media ${mediaQueries.xlPlusUp} {
    margin-top: 70px;
    margin-left: 0;
    max-width: 500px;
  }
  &:before {
    content: '';
    background: ${colors.pink};
    width: 50px;
    height: 4px;
    border-radius: 4px;
    position: absolute;
    top: -12px;
    left: calc(50% - 24px);
    @media ${mediaQueries.mdUp} {
      top: -18px;
    }
    @media ${mediaQueries.lgPlusUp} {
      top: -14px;
      left: -36px;
      width: 79px;
    }
  }
`;
const Title = styled.h3`
  color: ${colors.black3E};
  font-size: 18px;
  font-weight: normal;
  line-height: 25px;
  text-align: center;
  max-width: 286px;
  @media ${mediaQueries.mdUp} {
    font-size: 25px;
    line-height: 34px;
    max-width: 412px;
  }
  @media ${mediaQueries.lgPlusUp} {
    font-size: 30px;
    line-height: 44px;
    text-align: left;
  }
  @media ${mediaQueries.xlPlusUp} {
    font-size: 35px;
    max-width: max-content;
  }
`;
const DescriptionText = styled.p`
  color: ${colors.black3E};
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 0;
  margin-top: 8px;
  text-align: center;
  @media ${mediaQueries.mdUp} {
    font-size: 18px;
    line-height: 24px;
    padding: 0 16%;
    margin-top: 12px;
  }
  @media ${mediaQueries.lgPlusUp} {
    font-size: 17px;
    line-height: 32px;
    text-align: left;
    padding: 0;
  }
  @media ${mediaQueries.xlPlusUp} {
    font-size: 20px;
    line-height: 32px;
    margin-top: 6px;
  }
`;

const Action = ({ action }) => (
  <Media queries={mediaQueries}>
    {(matches) => {
      let image = action.images.desktop;
      let imageWebp = action.imagesWebp.desktop;
      if (matches.xlPlusDownLess) {
        image = action.images.tabletPro;
        imageWebp = action.imagesWebp.tabletPro;
      }
      if (matches.lgPlusDownLess) {
        image = action.images.tablet;
        imageWebp = action.imagesWebp.tablet;
      }
      if (matches.mdDownLess) {
        image = action.images.mobile;
        imageWebp = action.imagesWebp.mobile;
      }
      return (
        <Container>
          <ImageContainer>
            <source
              srcSet={imageWebp}
              type="image/webp"
            />
            <source
              srcSet={image}
              type="image/png"
            />
            <Image src={image} />
          </ImageContainer>
          <Description>
            <Title>
              {action.title}
            </Title>
            <DescriptionText>
              {action.description}
            </DescriptionText>
          </Description>
        </Container>
      );
    }}
  </Media>
);

Action.propTypes = {
  action: PropTypes.shape({
    key: PropTypes.string,
    images: PropTypes.shape({
      desktop: PropTypes.string,
      tabletPro: PropTypes.string,
      tablet: PropTypes.string,
      mobile: PropTypes.string,
    }),
    imagesWebp: PropTypes.shape({
      desktop: PropTypes.string,
      tabletPro: PropTypes.string,
      tablet: PropTypes.string,
      mobile: PropTypes.string,
    }),
    title: PropTypes.node,
    description: PropTypes.node,
  }).isRequired,
};

export default Action;
